/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderConfirmDto } from '../../models/shop-order-confirm-dto';
import { ShopOrderDetailDto } from '../../models/shop-order-detail-dto';

export interface ShopOrderClientControllerConfirmV1$Params {
      body: ShopOrderConfirmDto
}

export function shopOrderClientControllerConfirmV1(http: HttpClient, rootUrl: string, params: ShopOrderClientControllerConfirmV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
  const rb = new RequestBuilder(rootUrl, shopOrderClientControllerConfirmV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderDetailDto>;
    })
  );
}

shopOrderClientControllerConfirmV1.PATH = '/api/v1/shop-orders/client/confirm';
